import { useState } from "react";
import { logo } from "../assets";
import { baseUrl, secondaryColor } from "../constants/constants";
import ShowPasswordEye from "../components/Icons/ShowPasswordEye";
import HidePasswordEye from "../components/Icons/HidePasswordEye";
import { MainButton } from "../components";
import { useNavigate } from "react-router-dom";

const NewPassword = () => {
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [obscurePassword, setObscurePassword] = useState(true);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [obscureConfirmPassword, setObscureConfirmPassword] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handlePasswordVisibility = () => setObscurePassword(!obscurePassword);
  const handleConfirmPasswordVisibility = () =>
    setObscureConfirmPassword(!obscureConfirmPassword);

  const onButtonClick = () => {
    setPasswordError("");
    setConfirmPasswordError("");
    setErrorMessage("");

    if (!password) {
      setPasswordError("Password field is required!");
      return;
    }
    if (password.length < 8) {
      setPasswordError("The password must be 8 characters or longer");
      return;
    }
    if (password !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
      return;
    }

    setIsLoading(true);

    const token = localStorage.getItem("token");
    const email = localStorage.getItem("email");

    if (!token || !email) {
      setErrorMessage("Session expired. Please log in again.");
      setIsLoading(false);
      return;
    }

    fetch(`${baseUrl}reset-password`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    })
      .then(async (response) => {
        const result = await response.json();
        setIsLoading(false);
        console.log("API Response:", result);

        if (response.ok && result.status) {
          localStorage.setItem("token", result.token);
          navigate("/");
          window.location.reload();
        } else {
          setErrorMessage(result.message || "Failed to update password.");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setErrorMessage("Something went wrong. Please try again.");
        console.error("Error:", error);
      });
  };

  return (
    <div className="w-full h-screen flex-col items-center justify-center">
      <div className="min-h-screen flex flex-col items-center justify-center">
        <div className="flex sm:px-20 py-2 items-center lg:hidden">
          <img className="h-20" src={logo} alt="Logo" />
        </div>

        <div className="w-full flex justify-center">
          <div className="w-[90%] md:w-[600px] bg-white px-2 sm:px-10 py-10">
            <h1
              style={{ color: secondaryColor }}
              className="text-4xl font-bold text-center"
            >
              Password Reset
            </h1>
            <h1
              style={{ color: secondaryColor }}
              className="text-md text-center py-2"
            >
              Please enter your new password and confirm it below.
              <hr className="w-full md:w-[30%]" />
            </h1>

            <div className="py-10 flex w-full justify-center space-y-3 text-lg text-slate-600">
              <div className="flex flex-col items-center w-full">
                <div className="flex flex-col gap-2 w-full">
                  {/* New Password Field */}
                  <div className="flex flex-col w-full gap-1">
                    <label>New Password</label>
                    <div
                      className={`w-full flex border rounded-md ${
                        passwordError ? "border-red-500" : "border-slate-600/50"
                      }`}
                    >
                      <input
                        type={obscurePassword ? "password" : "text"}
                        value={password}
                        placeholder="New password"
                        onChange={(e) => setPassword(e.target.value)}
                        className="outline-none rounded-md px-3 py-2 w-full"
                      />
                      <button className="mr-2" onClick={handlePasswordVisibility}>
                        {obscurePassword ? (
                          <ShowPasswordEye className="h-6 w-6" />
                        ) : (
                          <HidePasswordEye className="h-6 w-6" />
                        )}
                      </button>
                    </div>
                    {passwordError && (
                      <label className="text-red-500 text-sm">{passwordError}</label>
                    )}
                  </div>

                  {/* Confirm Password Field */}
                  <div className="flex flex-col w-full gap-1">
                    <label>Confirm New Password</label>
                    <div
                      className={`w-full flex border rounded-md ${
                        confirmPasswordError ? "border-red-500" : "border-slate-600/50"
                      }`}
                    >
                      <input
                        type={obscureConfirmPassword ? "password" : "text"}
                        value={confirmPassword}
                        placeholder="Confirm new password"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="outline-none rounded-md px-3 py-2 w-full"
                      />
                      <button className="mr-2" onClick={handleConfirmPasswordVisibility}>
                        {obscureConfirmPassword ? (
                          <ShowPasswordEye className="h-6 w-6" />
                        ) : (
                          <HidePasswordEye className="h-6 w-6" />
                        )}
                      </button>
                    </div>
                    {confirmPasswordError && (
                      <label className="text-red-500 text-sm">
                        {confirmPasswordError}
                      </label>
                    )}
                  </div>
                </div>

                {/* Error Message */}
                {errorMessage && (
                  <div className="text-center text-md text-red-500 mt-3">
                    {errorMessage}
                  </div>
                )}

                {/* Submit Button */}
                <MainButton label="Change Password" onClick={onButtonClick} isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPassword;
